<div class="ws-popup-header">
  <span>{{ "Additional questions" | translate }}</span>
  <div class="actions">
    <button type="button" (click)="closeClicked()" mat-icon-button>
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<div class="ws-popup-content additional-questions-popup">
  <div class="ws-popup-body">
    <div *ngIf="loading" class="qa-loading">
      <mat-spinner diameter="32"></mat-spinner>
    </div>

    <ng-container *ngIf="!loading">
      <div class="qa-item" *ngFor="let answer of answers; let last = last" [class.qa-item--last]="last">
        <div class="qa-question">{{ questionText(answer) }}</div>
        <div class="qa-answer">
          <div *ngIf="isMultipleChoiceAnswer(answer)" class="qa-answer-multiple">
            <span class="qa-answer-badge" *ngFor="let label of answerLabels(answer)">{{ label }}</span>
          </div>
          <ng-container *ngIf="!isMultipleChoiceAnswer(answer)">{{ answerText(answer) }}</ng-container>
        </div>
      </div>
      <p *ngIf="answers.length === 0" class="qa-empty">{{ "No answers" | translate }}</p>
    </ng-container>
  </div>

  <div class="ws-popup-footer border-top-gray">
    <ws-button (click)="closeClicked()" [callToActionType]="'primary'">
      {{ "Close" | translate }}
    </ws-button>
  </div>
</div>
